import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { vservice } from '@niknevis/vue-modules'
import { Data } from '@/modules/shared/models/data'
import { PanelContentItemService } from '@/modules/content-item/services/panel-content-item.service'
import { ContentItemCollectionModel } from '@/modules/content-item/models/content-item-collection.model'

@vservice()
export class PanelContentItemGetItemsUseCase {
  constructor(
    private readonly service: PanelContentItemService
  ) {
  }

  private remoteData = RemoteData
    .notAsked<Data<ContentItemCollectionModel[]>>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get data(): Data<ContentItemCollectionModel[]> {
    return this.remoteData.fold(
      () => void 0,
      value => value || void 0,
      value => value,
      (error, value) =>
        value || void 0
    )
  }

  execute(data = {}) {
    return this.remoteData.fromPromise(
      this.service.getItems(data)
    )
  }
}
